module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/download-drop-9edf8bb5b36edf53d1a4623076c65d31.svg";